export const saveBlobAsFile = (() => {
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.style = 'display: none';

    return (blob) => {
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = blob.name || 'file';
        link.click();
        window.URL.revokeObjectURL(url);
    };
})();
